<template>
    <ul :class="`c-checklist ${customClass ? customClass : ''}`">
        <slot></slot>
    </ul>
</template>

<script>
    import Vue from 'vue'
    import ChecklistItem from './ChecklistItem'

    // Register subcomponents
    Vue.component('v-checklist-item', ChecklistItem);

    export default {
        props: ['custom-class']
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-checklist {
        list-style: none;
        margin: 0;
        padding: 0;

        > *{
           &:not(:last-child){
               margin-bottom: em($global-spacing-unit-tiny);
           }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/checklist/Checklist.vue